import { getClassDetails, getTeachingMaterials, getMeterialRemarkDetail, setTeachingMaterials as setTeachingMaterialsAPI, getIsDivertUser, getMaterialsByDivertUser, setMaterialsByDivertUser } from '@/api/classtable'
import {getUserInfo} from '@/api/user'
function hasMaterials (state) {
  return !!state.info.GetUserCatagory
}
function GetUCID (state) {
  return hasMaterials(state) ? state.info.GetUserCatagory.UCID : null
}

function currentLesson (state) {
  if (!state.teachingMaterials || !state.teachingMaterials.length) {
    return null
  }
  // 取第一个CSID > 0的课程
  const materials = state.teachingMaterials
  const hasCSID = materials.find(m => m.CSID > 0)
  if (hasCSID) {
    return hasCSID
  }
  // lastMatched = 最后一个USID或者USAID大于零的课
  // 若存在则取该课的后一节
  // 若不存在则取第一节不是目录的课
  const lastMatched = materials.slice().reverse().find(m => m.USID > 0 || m.USAID > 0)
  if (lastMatched) {
    return materials.find(m => m.RowNum === (lastMatched.RowNum + 1))
  }
  return materials.find(m => m.IsRemark === 'True' || m.IsRemark === true)
}
function meterialList (state) {
  if (!hasMaterials(state)) {
    return []
  }
  const hasCurrentLesson = currentLesson(state)
  const CurrentLessonRowNum = hasCurrentLesson ? hasCurrentLesson.RowNum : -1
  // 课程计数, 循环到普通课程的时候加1
  let normalLessonNumber = 1
  return state.teachingMaterials.map(m => {
    // 1 已学课程, 2 目录, 3 测试课程, 4 未完成课程
    let lessonType = 4
    if (m.ClassType > 0) {
      lessonType = 3
    } else if (m.USID > 0) {
      lessonType = 1
    } else if (!(m.IsRemark === 'True' || m.IsRemark === true)) {
      lessonType = 2
    }
    return {
      title: lessonType === 3 ? 'Test Lesson' : lessonType === 2 ? 'Teaching Plan' : normalLessonNumber++,
      isCurrentLesson: state.diver ? m.IsCurrentCourseware : m.RowNum === CurrentLessonRowNum,
      lessonName: m.SubjectName,
      lessonType,
      originData: m,
      SID: m.SID,
      CatId:m.CatId,
      IsTest:m.IsTest, //是否试课课件
      UnitID:m.UnitID, //单元ID
      Sort:'Unit '+m.Sort, //单元排序
      VipNumber:'Lesson '+m.VipNumber, //VIP课件排序
      TestNumber:'Lesson '+m.TestNumber //测试课件排序
    }
  })
}
const isTest = (state) => state.info.istext
const classDetail = {
  namespaced: true,
  state: {
    info: {},
    teachingMaterials: [],
    loading: false,
    loadingMaterials: false,
    diver:false,
    lessonPlan:{
      dialog:false,
      clid:0,
      classStatus:"",
      classTime:"",
      edit:""
    },
    agora:{}
  },
  mutations: {
    SET_TEACHING_METERIALS: (state, meterial) => {
      state.teachingMaterials = meterial
    },
    SET_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_LOADING_MATERIALS: (state, loadingMaterials) => {
      state.loadingMaterials = loadingMaterials
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_DIVERT_USER:(state,diver)=>{
      state.diver = diver
    },
    lessonPlanDialog:(state,info)=>{
      state.lessonPlan.dialog = true
      state.lessonPlan.clid = info.clid
      state.lessonPlan.classStatus = info.classStatus
      state.lessonPlan.classTime = info.classTime
      state.lessonPlan.edit = info.edit
    },
    SET_TEACHING_AGORA:(state,data)=>{
      console.log(data);
      state.agora = data
    }
  },
  actions: {
    async fetchInfo ({ commit }, id) {
      commit('SET_LOADING', true)
      await getClassDetails(id)
        .then(info => {
          commit('SET_INFO', info)
        })
        .finally(() => {
          commit('SET_LOADING', false)
        })
    },
    async fetchMeterials ({ state, commit }) {
      if (hasMaterials(state)) {
        commit('SET_LOADING_MATERIALS', true)
        if(state.diver){
          // 分流用户
          await getMaterialsByDivertUser(state.info.CLID,state.info.StuUID)
          .then(res=>{
            commit('SET_TEACHING_METERIALS', res)
          }).finally(() => {
            commit('SET_LOADING_MATERIALS', false)
          })
        }else{
          await getTeachingMaterials(GetUCID(state), isTest(state))
          .then(res => {
            commit('SET_TEACHING_METERIALS', res)
          })
          .finally(() => {
            commit('SET_LOADING_MATERIALS', false)
          })
        }
      }
    },
    setTeachingMaterials ({ state, dispatch }, {SID, CatId}) {
      if (!hasMaterials(state)) {
        return Promise.reject(new Error('Please wait for Teaching Material fully loaded.'))
      }
      if(state.diver){
        setMaterialsByDivertUser(state.info.CLID,state.info.StuUID,SID,CatId)
        .then(res=>{
          // 修改成功则重新载入
          dispatch('fetchMeterials')
        })
      }else{
        return setTeachingMaterialsAPI({
          UCID: state.info.GetUserCatagory.UCID,
          SID,
          UID: state.info.StuUID,
          CLID: state.info.CLID
        }).then(res => {
          // 修改成功则重新载入
          dispatch('fetchMeterials')
        })
      }
    },
    fetchMaterialRemark ({ state }, { SID, UCID }) {
      return getMeterialRemarkDetail({ SID, UCID })
    },
    async hasDiverUser({state,commit}){
      if(hasMaterials(state)){
        await getIsDivertUser(state.info.StuUID).then((res)=>{
          commit('SET_DIVERT_USER',res)
        })
      }
    }
  },
  getters: {
    info: state => state.info,
    teachingMaterials: state => state.teachingMaterials,
    loading: state => state.loading,
    classStatus: state => {
      const isFinished = state.info.IsOverClass || false
      const isCorrect = state.info.SID > 0
      if (!isFinished && !isCorrect) {
        return 'unfinished'
      } else if (isFinished && isCorrect) {
        return 'finished'
      }
      return 'incorrectFinished'
    },
    loadingMaterials: state => state.loadingMaterials,
    hasMaterials: hasMaterials,
    UCID: GetUCID,
    currentLesson,
    meterialList,
    userCatagory: state => state.info.GetUserCatagory || {},
    lessonPlan: state => state.lessonPlan
  }
}
export default classDetail
